export const APP_ROUTES = {
  ADMIN: "/admin",
  ADMIN_USER: "/admin/user",
  ADMIN_REFERRAL: "/admin/referral",
};
